/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mlp-ng-icon.xlarge i{font-size:9.5rem!important;line-height:.8}"];
export { styles as styles };
